import React, { Component, Fragment } from 'react'
import { Popover, Overlay, Button } from 'react-bootstrap'

import './style.css'

class ConfirmationPopover extends Component {

  state = {
    showPopover: false,
    popoverTarget: null,
  }

  toggleShowPopover = (e) => {
    if (this.state.showPopover) {
      return this.setState({ showPopover: false, popoverTarget: null })
    } else {
      return this.setState({ showPopover: true, popoverTarget: e.target })
    }
  }

  handleConfirm = () => {
    this.toggleShowPopover()
    this.props.onConfirm()
  }

  handleCancel = () => {
    this.toggleShowPopover()
    this.props.onCancel()
  }

  render() {
    const {
      triggerText,
      triggerVariant,
      title,
      popoverContent,
      placement,
      confirmText,
      cancelText,
      triggerButtonClass,
      confirmButtonVariant,
      popoverClassName,
      disabled
    } = this.props


    return (
      <Fragment>
        <Button
          variant={triggerVariant}
          onClick={this.toggleShowPopover}
          className={triggerButtonClass}
          disabled={disabled}
        >
          {triggerText}
        </Button>

        <Overlay
          show={this.state.showPopover}
          target={this.state.popoverTarget}
          placement={placement}
          onHide={this.toggleShowPopover}
          rootClose
        >
          <Popover className={popoverClassName}>
            <Popover.Title>
              {title}
            </Popover.Title>

            <Popover.Content>
              {popoverContent}
              <br/>

              <center>
                <Button
                  variant={confirmButtonVariant}
                  onClick={this.handleConfirm}
                  className="confirm-popover-button"
                  disabled={disabled}
                >
                  {confirmText}
                </Button>
              </center>

              <br/>

              <center>

                <Button
                  onClick={this.handleCancel}
                  className="cancel-popover-button"
                  disabled={disabled}
                >
                  {cancelText}
                </Button>
              </center>
            </Popover.Content>
          </Popover>
        </Overlay>
      </Fragment>
    )
  }
}

ConfirmationPopover.defaultProps = {
  triggerText: '',
  triggerVariant: 'danger',
  title: '',
  popoverContent: '',
  placement: 'top',
  onConfirm: () => null,
  onCancel: () => null,
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  confirmButtonVariant: 'danger',
  popoverClassName: '',
}


export default ConfirmationPopover
